import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { provideMarkdown } from 'ngx-markdown';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { authInterceptor } from './auth-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        options: {
          darkModeSelector: '.dark-mode'
        },
        preset: definePreset(Aura, {
          semantic: {
            primary: {
              50: '#f2f7fd',
              100: '#e4edfa',
              200: '#c3daf4',
              300: '#8ebceb',
              400: '#529ade',
              500: '#2b7dcc',
              600: '#1c62ad',
              700: '#184e8c',
              800: '#174170',
              900: '#193a61',
              950: '#112540'
            }
          }
        })
      }
    }),
    ConfirmationService,
    MessageService,
    provideMarkdown()
  ]
};